export default __webpack_public_path__ + "static/wp_line_basic_banner-6bc5ce47b2db44943a07f7b208091280.png";